import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';

import { themeSVGBase64 } from '../../utils/image';

import JerryLogo from './assets/logotype-primary.svg';
import JerryLogoMark from './assets/logomark-primary.svg';

export type JerryLogoColor = 'grey' | 'black' | undefined | 'white';

interface LogoProps {
  className?: string;
  markOnly?: boolean;
  color?: JerryLogoColor;
  primary?: boolean;
}

/**
 * Get proper Jerry logo image based on prop.
 * @param markOnly - Decideds between full logo vs mark only logo.
 * @param grey - Decides if logo should be in grey color.
 * @param primaryColor - Decides if logo should be in primary color of current theme.
 */
const getLogoImage = (markOnly, color, primaryColor) => {
  if (color === 'grey')
    return markOnly
      ? themeSVGBase64(JerryLogoMark, '#FF3975', '#6B7A86')
      : themeSVGBase64(JerryLogo, '#FF3975', '#6B7A86');
  if (color === 'black')
    return markOnly ? themeSVGBase64(JerryLogoMark, '#FF3975', 'black') : themeSVGBase64(JerryLogo, '#FF3975', 'black');
  if (color === 'white')
    return markOnly ? themeSVGBase64(JerryLogoMark, '#FF3975', 'white') : themeSVGBase64(JerryLogo, '#FF3975', 'white');
  if (primaryColor)
    return markOnly
      ? themeSVGBase64(JerryLogoMark, '#FF3975', primaryColor)
      : themeSVGBase64(JerryLogo, '#FF3975', primaryColor);
  return markOnly ? JerryLogoMark : JerryLogo;
};

/**
 * Logo component
 */
const UnstyledLogo: FunctionComponent<LogoProps> = ({ className }) => {
  return <div className={className} />;
};

export const Logo = styled(UnstyledLogo)`
  background-image: url(${({ markOnly, color, primary, theme }) =>
    getLogoImage(markOnly, color, primary ? theme.palette.primary.main : null)});
  width: ${({ markOnly }) => (markOnly ? 28 : 105)}px;
  height: ${({ markOnly }) => (markOnly ? 16 : 26)}px;
  @media (max-width: ${({ theme }) => theme.breakpoints.ipad}px) {
    width: ${({ markOnly }) => (markOnly ? 28 : 77)}px;
    height: ${({ markOnly }) => (markOnly ? 16 : 19)}px;
  }
  background-repeat: no-repeat;
  background-size: cover;
`;
